module.exports = __webpack_public_path__ + "static/tactics_notebook_tablet_pozemni_hokej-370120e5c9d9381591989d46ba12eb90.mp4";